module.exports = __webpack_public_path__ + "static/media/azzule-example.b35aa5c2.png";